module.exports = __webpack_public_path__ + "img/369camera.7f446bdf(2).214a17a2.png";